export function tabUnderline($) {
    // Append underline element
    $('.tab-links').append('<span class="underline"></span>');

    // Select the first tab link element
    var el = $('.tab-links .tab-link-wrap').first();

    // Set the initial width of the underline element
    $('.tab-links .underline').width(el.outerWidth());

    // Event handlers for mouseenter and mouseleave
    $('.tab-links .tab-link-wrap a').on('mouseenter', function () {
        var parent = $(this).parent();
        var posLeft = parent.position().left;
        var parentWidth = parent.outerWidth();

        // Set the width and position of the underline element
        $('.tab-links .underline').css({
            'transform': 'translateX(' + posLeft + 'px)',
            'width': parentWidth
        });
    }).on('mouseleave', function () {
        // Reset the underline element to the initial position and width
        var initialWidth = el.outerWidth();
        $('.tab-links .underline').css({
            'transform': 'translateX(0)',
            'width': initialWidth
        });
    });
}

export function tabLinksMobile($) {
    if ($(window).width() <= 767) {
        var tabCon = $('.tab-links-container');

        // console.log(tabCon);
        if (tabCon[0]) {
            tabCon.prepend('<div id="tabLinkBox"></div>');

            var tabLinkBox = $('#tabLinkBox');
            var firstBlockText = $('.tab-links .tab-link-wrap a').first().text();
            var tabLinksDropdown = $('.tab-links');

            tabLinkBox.text(firstBlockText);

            tabLinkBox.on('click', function () {
                tabLinksDropdown.toggleClass('active');
            });

            var $navbar = tabCon;
            var sticky = $navbar.offset().top;  // Get the initial position of the navbar
            // var $sections = $('.section-sticky');  // Select all sections
            // Initialize $sections based on tab link href targets
            var $sections = $($.map($('.tab-link-wrap a'), function (link) {
                var targetId = $(link).attr('href');
                return targetId ? $(targetId)[0] : null;
            }));
            var $navLinks = $('.tab-link-wrap a');  // Select all navbar links
            var mainNavHeight = $('header.theme-header').outerHeight();

            $navLinks.on('click', function () {
                tabLinksDropdown.removeClass('active');
            })

            if ($sections) {

                // Get the bottom of the last section to stop the sticky behavior
                var lastSection = $sections.last();
                var lastSectionBottom = lastSection.offset().top + lastSection.outerHeight();

                // Sticky Navbar function
                function stickyNavbar() {
                    var scrollTop = $(window).scrollTop();

                    if (scrollTop >= (sticky - mainNavHeight) && scrollTop < lastSectionBottom - $navbar.outerHeight()) {
                        $navbar.addClass('sticky');
                    } else {
                        $navbar.removeClass('sticky');
                    }
                }

                // Set active nav link function
                function setActiveNavLink() {
                    var scrollTop = $(window).scrollTop();
                    var headerHeight = $('header.theme-header').outerHeight();

                    // Include additional height for the tab links container if visible
                    var tabLinksContainerHeight = $('.tab-links-container:visible').outerHeight() || 0;
                    headerHeight += tabLinksContainerHeight;

                    var currentIndex = $sections.length;

                    // Check which section is currently in view, skipping hidden sections
                    $sections.each(function (index) {
                        var $section = $(this);

                        // Skip if the section is hidden (e.g., in tabs)
                        if (!$section.is(':visible')) return;

                        // Get section-specific padding-top
                        var sectionPaddingOffset = parseInt($section.css('padding-top'), 10) || 0;

                        // Calculate the section's position relative to scroll and header height
                        var sectionTop = $section.offset().top;
                        var adjustedScrollPosition = scrollTop + headerHeight + sectionPaddingOffset + 50;

                        // Set the current index based on visibility and scroll position
                        if (adjustedScrollPosition >= sectionTop) {
                            currentIndex = index;

                            // Set text for the active tab link if applicable
                            if ($navLinks.hasClass('active')) {
                                tabLinkBox.text($('.tab-link-wrap a.active').text());
                            }
                        }
                    });

                    // Remove active class from all nav links
                    $navLinks.removeClass('active');

                    // Add active class to the current section's corresponding nav link
                    $navLinks.eq(currentIndex).addClass('active');
                }

                // Call setActiveNavLink on scroll and resize to handle mobile adjustments dynamically
                $(window).on('scroll resize', function () {
                    stickyNavbar(); // Assume stickyNavbar is a separate function defined elsewhere
                    setActiveNavLink();
                });


            }
        }
    }
}

export function tabLinksAnchor($) {
    $('.tab-link-wrap a').on('click', function (e) {
        e.preventDefault();

        var targetId = $(this).attr('href');
        var targetElement = $(targetId);
        var headerHeight = $('header.theme-header').outerHeight();

        if ($(window).width() < 768) {
            var tabLinksContainer = $('.tab-links-container').outerHeight();
            headerHeight += tabLinksContainer;
        }

        // Get the section padding offset
        var sectionPaddingOffset = parseInt(targetElement.css('padding-top'), 10) || 0;
        headerHeight += sectionPaddingOffset;

        if (targetElement.length) {
            var position = targetElement.offset().top;
            var scrollToPosition = position - headerHeight;

            // Animate the scroll to the adjusted position
            $('html, body').animate({
                scrollTop: scrollToPosition
            }, 300); // Adjust the duration as needed
        }
    });
}
